import React from 'react';
import Image from '@bitcoin-portal/bitcoincom-pkg-components/dist/Image';
import { Sublink, Subheading, TitleContainer, ComingSoon } from '../styled';
import { icons } from '../../../../icons';
const SublinkComponent = ({ sublinkId, url, subheading, icon, alt, text, contrast, }) => {
    const sublinkIcon = icons[icon || ''];
    return (React.createElement(Sublink, { href: url, className: "universal-menu-link sublink", rel: "canonical", contrast: contrast },
        React.createElement(TitleContainer, null,
            sublinkIcon && alt && React.createElement(Image, { src: sublinkIcon, alt: alt, width: 23 }),
            sublinkId,
            text && (React.createElement(React.Fragment, null,
                React.createElement("span", { style: { flex: '1 1 0' } }),
                " ",
                React.createElement(ComingSoon, null, text)))),
        React.createElement(Subheading, { contrast: contrast }, subheading)));
};
export default SublinkComponent;
//# sourceMappingURL=Sublink.js.map